module.exports = __webpack_public_path__ + "img/t1-1.58d9ca9a.jpg";